<template>
    <div class="account">
        <el-breadcrumb separator-class="el-icon-arrow-right" v-if="postList.headerTitle">
            <el-breadcrumb-item>物流跟踪</el-breadcrumb-item>
        </el-breadcrumb>
        <el-row class="main_header">
            <div class="main_header_item" v-show="postList.is_show_search">
                <el-input v-model="queryParams.id" placeholder="请输入ID" clearable @keyup.enter.native="getList(1)"></el-input>
            </div>
            <div class="main_header_item" v-show="postList.is_show_search">
                <el-input v-model="queryParams.number" placeholder="请输入物流单号" clearable @keyup.enter.native="getList(1)"></el-input>
            </div>
            <div class="main_header_item" v-show="postList.is_show_search">
                <vDropdown
                    model_key="transaction_type_code"
                    model_name="请选择交易类型"
                    select_value="value"
                    request_uri="dropdownTransactionType"
                    :model_value_default="queryParams['transaction_type_code']"
                    @onDropChange="onDropChange"
                    :request_params="{ without_beginning: true }"
                    ref="transaction_type_code_ref"
                ></vDropdown>
            </div>
            <div class="main_header_item" v-show="postList.is_show_search">
                <el-input
                    v-model="queryParams.transaction_number"
                    placeholder="请输入交易单号"
                    clearable
                    @keyup.enter.native="getList(1)"
                ></el-input>
            </div>
            <div class="main_header_item" v-show="postList.is_show_search">
                <vDropdown
                    model_key="logistics_status"
                    model_name="请选择物流状态"
                    select_value="value"
                    request_uri="dropdownLogisticsStatus"
                    :model_value_default="queryParams['logistics_status']"
                    @onDropChange="onDropChange"
                    ref="logistics_status_ref"
                ></vDropdown>
            </div>
            <div class="main_header_item" v-show="postList.is_show_search">
                <vDropdown
                    model_key="type"
                    model_name="请选择类型"
                    select_value="value"
                    request_uri="dropdownLogisticsType"
                    :model_value_default="queryParams['type']"
                    @onDropChange="onDropChange"
                    ref="type_ref"
                ></vDropdown>
            </div>
            <div class="main_header_item" v-show="postList.is_show_search">
                <el-input
                    v-model="queryParams.logistics"
                    placeholder="请输入物流方式"
                    clearable
                    @keyup.enter.native="getList(1)"
                ></el-input>
            </div>
            <div class="main_header_item" v-show="postList.is_show_search">
                <el-input v-model="queryParams.carrier" placeholder="请输入物流公司" clearable @keyup.enter.native="getList(1)"></el-input>
            </div>
            <div class="main_header_item" v-show="postList.is_show_search">
                <el-date-picker
                    v-model="queryParams['shipment_time_range']"
                    type="daterange"
                    start-placeholder="发货时间"
                    end-placeholder="发货时间"
                    value-format="yyyy-MM-dd"
                    size="small"
                    style="width: 300px"
                >
                </el-date-picker>
            </div>

            <div class="main_header_item" v-show="postList.is_show_search">
                <el-date-picker
                    v-model="queryParams['expected_delivery_time_range']"
                    type="daterange"
                    start-placeholder="预计到货时间"
                    end-placeholder="预计到货时间"
                    value-format="yyyy-MM-dd"
                    size="small"
                    style="width: 300px"
                >
                </el-date-picker>
            </div>

            <div class="main_header_item" v-show="postList.is_show_search">
                <el-date-picker
                    v-model="queryParams['receipt_time_range']"
                    type="daterange"
                    start-placeholder="签收时间"
                    end-placeholder="签收时间"
                    value-format="yyyy-MM-dd"
                    size="small"
                    style="width: 300px"
                >
                </el-date-picker>
            </div>

            <div class="main_header_item" v-show="postList.is_show_search">
                <el-date-picker
                    v-model="queryParams['receipt_time_adjusted_range']"
                    type="daterange"
                    start-placeholder="签收时间(手动)"
                    end-placeholder="签收时间(手动)"
                    value-format="yyyy-MM-dd"
                    size="small"
                    style="width: 300px"
                >
                </el-date-picker>
            </div>
        </el-row>
        <div class="main_list">
            <div class="flex">
                <el-button size="small" plain @click="syncFromK3" :loading="btnLoading">同步自金蝶</el-button>
                <div class="main_header_btns">
                    <el-button type="primary" size="small" @click="getList(1)" v-if="postList.searchBtn">搜索</el-button>
                    <el-button size="small" type="primary" plain @click="reset" v-if="postList.resetBtn">重置</el-button>
                    <el-button
                        size="small"
                        plain
                        icon="el-icon-bottom"
                        @click="getList(2)"
                        :loading="down_loading"
                        v-if="postList.downFileBtn"
                        >下载</el-button
                    >
                    <draggableList :draggable="draggable" @isErrShow="onSetFieldDone" v-if="postList.setBtn"></draggableList>
                </div>
            </div>
            <el-table
                :data="tableData"
                border
                ref="tableDataRef"
                :max-height="this.$tableHeight"
                class="transaction_logistics"
                @header-dragend="changeColWidth"
                v-loading="loading"
                element-loading-text="拼命加载中"
                element-loading-spinner="el-icon-loading"
                element-loading-background="rgba(255, 255, 255, 0.8)"
                style="width: 100%"
            >
                <template v-for="(item, index) in colData">
                    <el-table-column
                        :key="index"
                        :prop="item.prop"
                        :label="item.title"
                        :min-width="item.width"
                        :sortable="item.sort"
                        align="left"
                        show-overflow-tooltip
                        v-if="colData[index].is_show"
                    >
                        <template slot-scope="scope">
                            <div v-if="in_array(item.prop, ['number'])">
                                <el-link type="primary" @click="toDetail(scope.row, item.prop)" style="font-size: 11px"
                                    >{{ scope.row[item.prop] }}
                                </el-link>
                            </div>
                            <div v-else>
                                <span> {{ scope.row[item.prop] }} </span>
                            </div>
                        </template>
                    </el-table-column>
                </template>
            </el-table>
            <div class="pagination">
                <el-pagination
                    background
                    layout="total,prev, pager, next, sizes, jumper"
                    @current-change="currentChange"
                    @size-change="sizeChange"
                    :page-sizes="[10, 25, 50, 75, 100]"
                    :current-page="queryParams.page"
                    :page-size="queryParams.row"
                    :total="total"
                ></el-pagination>
            </div>
        </div>
    </div>
</template>
<script>
import { onReSize, onSearch, in_array, onDelete } from '@/js/common.js';
import draggableList from '@/components/common/Drawer.vue';
import crmUpload from '@/components/common/Upload.vue';
import vSearchSelect from '@/components/common/dropdown/search.vue';

export default {
    inject: ['reload'],
    //注册draggable组件
    components: {
        draggableList,
        crmUpload,
        vSearchSelect
    },
    name: 'transactionLogisticsComponent',
    data() {
        return {
            draggable: {
                data_name: 'transaction_logistics'
            },
            down_loading: false,
            btnLoading: false,
            loading: true,
            tableData: [],
            colData: [],
            total: 0,
            // sort: '', //排序参数
            // data_name: '', //排序参数
            queryParams: {}
        };
    },
    props: {
        postList: {
            type: Object
        }
    },
    beforeMount() {
        this.recoveryQueryParams('page');
    },
    mounted() {
        this.$nextTick(() => {
            this.selectedColData(); //筛选列
            this.recoveryQueryParams();
            if (this.postList.params) {
                this.queryParams.row = 10;
                this.queryParams.transaction_number = this.postList.params.transaction_number || '';
                this.getList(0);
            } else {
                this.getList(0); //获取列表
            }
        });
    },
    methods: {
        in_array,
        //跳转详情
        toDetail(row, prop) {
            if (prop == 'number' && row.id) {
                this.$router.push({
                    path: '/transactionLogisticsDetail',
                    query: {
                        id: row.id
                    }
                });
            }
        },
        initQueryParams() {
            this.queryParams = {
                page: 1,
                row: 25,
                is_export: 0
            };

            this.saveQueryParams();
        },
        onDropChange(key, value) {
            this.queryParams[key] = value;
        },
        saveQueryParams() {
            if (!this.postList.params) {
                localStorage.setItem('transaction_logistics_params', JSON.stringify(this.queryParams));
            }
        },
        // 分页参数需要在beforeMount初始化，先兼容下
        recoveryQueryParams(type = 'common') {
            //详情内调用不用本地存储的params
            if (!this.postList.params) {
                //列表页面调用 优先取本地存储
                const queryParams = JSON.parse(localStorage.getItem('transaction_logistics_params'));
                if (queryParams) {
                    if (type == 'common') {
                        this.queryParams = queryParams;
                    } else {
                        this.queryParams.page = queryParams.page || 1;
                        this.queryParams.row = queryParams.row || 25;
                    }
                } else {
                    this.initQueryParams();
                }
            }
        },
        //子组件更新完毕
        onSetFieldDone(data) {
            //刷新下页面
            this.reload();
        },
        //列宽改变事件
        changeColWidth(nw, ow, col, evt) {
            onReSize('transaction_logistics', this);
        },
        //筛选列
        selectedColData() {
            this.colData = JSON.parse(localStorage.getItem('dataList')).transaction_logistics;
        },
        // 获取列表 0-非搜索 1-搜索 2-下载
        getList(search_type = 0) {
            onSearch(search_type, this, 'transactionLogisticsLists');
        },
        currentChange(page) {
            this.queryParams.page = page;
            this.saveQueryParams();
            this.getList(0);
        },
        sizeChange(row) {
            this.queryParams.row = row;
            this.saveQueryParams();
            this.getList(0);
        },
        reset() {
            this.initQueryParams();
            this.$refs.transaction_type_code_ref.reset();
            this.$refs.logistics_status_ref.reset();
            this.$refs.type_ref.reset();
            this.getList();
        },
        syncFromK3() {
            this.$confirm('您确定要同步吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
                closeOnPressEscape: false,
                closeOnClickModal: false
            })
                .then(() => {
                    this.btnLoading = true;
                    this.$api['transactionLogisticsSyncFromK3']({})
                        .then((res) => {
                            if (res.code == 0) {
                                this.$message({
                                    message: '操作成功!',
                                    type: 'success'
                                });
                                this.reload();
                            }
                        })
                        .catch((error) => {
                            this.btnLoading = false;
                        });
                })
                .catch(() => {});
        }
    }
};
</script>
<style lang="scss" scoped>
/deep/ .el-table__empty-block {
    width: 100% !important;
    min-width: 100% !important;
    max-width: 100% !important;
    padding-right: 100% !important;
}
</style>